<div class="tw-h-full tw-w-full tw-bg-gray-75 tw-flex tw-flex-col tw-gap-6 tw-p-6">
  @if (showQuestion()) {
    <app-quiz-progress-header [percent]="progressPercent()" [stepLabel]="stepLabel()" (closed)="onCloseClicked()" />
  }
  <div class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-flex tw-flex-col tw-gap-6">
    @if (showQuestion()) {
      <app-quiz-question-header [heading]="quizService.questionText()" [subText]="quizService.questionSubText()" />
      @switch (quizService.layout()) {
        @case (QuizQuestionLayout.Text) {
          <app-quiz-text-answer
            [placeholder]="quizService.textPlaceholder()"
            [disabled]="inputsDisabled()"
            [showVoice]="showVoice()"
            (valueChange)="onTypedTextChange($event)" />
        }
        @case (QuizQuestionLayout.MultiSelect) {
          <app-quiz-option-list
            [options]="quizService.buttonOptions()"
            [multiSelect]="true"
            [type]="optionListType()"
            [disabled]="inputsDisabled()"
            (selectionChange)="onSelectionChange($event)" />
        }
        @case (QuizQuestionLayout.PhotoUpload) {
          <app-quiz-photo-upload (capture)="onContinue()" (openInstantCheckup)="onOpenInstantCheckup($event)" />
        }
        @default {
          @if (quizService.imageOptions().length) {
            <app-quiz-image-option-grid
              [options]="quizService.imageOptions()"
              [disabled]="inputsDisabled()"
              [showIndex]="showImageOptionIndex()"
              (selectionChange)="onImageSelectionChange($event)" />
          }
          @if (quizService.buttonOptions().length) {
            <app-quiz-option-list
              [options]="quizService.buttonOptions()"
              [type]="optionListType()"
              [disabled]="inputsDisabled()"
              (selectionChange)="onButtonSelectionChange($event)" />
          }
        }
      }
    } @else if (showLoading()) {
      <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center">
        <loading [size]="48" [stroke]="'var(--cureskin-teal-600)'"></loading>
      </div>
    }
    @if (quizService.errorMessage()) {
      <p class="tw-text-300 tw-text-red-500">{{ quizService.errorMessage() }}</p>
    }
  </div>
  @if (showQuestion()) {
    <app-quiz-footer-cta [label]="ctaLabel()" [icon]="ctaIcon()" [disabled]="ctaDisabled()" [loading]="isSubmittingAnswer()" (pressed)="onContinue()" />
  }
</div>
